module.exports = __webpack_public_path__ + "img/second-title.50eae3d3.svg";